'use es6';

import { Map as ImmutableMap, fromJS } from 'immutable';
import { CLOSE_MODAL, OPEN_MODAL, OPEN_SOCIAL_COMPOSER, CLOSE_SOCIAL_COMPOSER, UPDATE_SOCIAL_COMPOSER_PARAMS, REQUESTED_ATTACH_TO_LANGUAGE_MASTER_FAILED, REQUESTED_CREATE_TRANSLATION_VARIATION_FAILED, REQUESTED_UNPUBLISH_CONTENT_FAILED, REQUESTED_PUBLISH_CONTENT_FAILED, OPEN_ADS_PANEL, CLOSE_ADS_PANEL } from '../actions/ActionTypes';
import ModalsDisplay from '../models/ModalsDisplay';
export default ((state = new ModalsDisplay(), action) => {
  switch (action.type) {
    case OPEN_MODAL:
      return ModalsDisplay.fromJS({
        modalOverrides: action.payload.modalOverrides,
        openModalName: action.payload.modalName
      });
    case CLOSE_MODAL:
      return new ModalsDisplay();
    case REQUESTED_ATTACH_TO_LANGUAGE_MASTER_FAILED:
      {
        const error = action.payload.responseJSON || {};
        return state.setIn(['errors', 'attachToLanguageMaster'], fromJS(error));
      }
    case REQUESTED_CREATE_TRANSLATION_VARIATION_FAILED:
      {
        const error = action.payload.responseJSON || {};
        return state.setIn(['errors', 'createTranslationVariation'], fromJS(error));
      }
    case REQUESTED_PUBLISH_CONTENT_FAILED:
      {
        const error = action.payload.responseJSON || {};
        return state.setIn(['errors', 'publish'], fromJS(error));
      }
    case REQUESTED_UNPUBLISH_CONTENT_FAILED:
      {
        const error = action.payload.responseJSON || {};
        return state.setIn(['errors', 'unpublish'], fromJS(error));
      }
    case OPEN_SOCIAL_COMPOSER:
      return state.merge({
        socialComposerOpen: true,
        socialComposerParams: ImmutableMap(action.payload)
      });
    case UPDATE_SOCIAL_COMPOSER_PARAMS:
      return state.mergeIn(['socialComposerParams'], action.payload);
    case CLOSE_SOCIAL_COMPOSER:
      return state.merge({
        socialComposerOpen: false,
        socialComposerParams: ImmutableMap({})
      });
    case OPEN_ADS_PANEL:
      return state.merge({
        adsPanelOpen: true
      });
    case CLOSE_ADS_PANEL:
      return state.merge({
        adsPanelOpen: false
      });
    default:
      return state;
  }
});